import {createAsyncThunk} from '@reduxjs/toolkit';
import {useSelector} from 'react-redux';

import {Constants} from '../../../constants';
import {Store} from '../../redux/types';
import {appSettingsSelector} from '../slices/appSettingsSlice';
import {
  connectedPeakSelector,
  currentDeviceSelector,
  updateDevice,
} from '../slices/bleSlice';
import {toHeatProfile} from './bleReadDeviceSettings';

export const bleReadTempHeatProfile = createAsyncThunk<void>(
  'ble/readTempHeatProfile',
  async (_, {dispatch, getState}) => {
    const state = getState() as Store;
    const peak = connectedPeakSelector(state);
    const currentDevice = currentDeviceSelector(state);
    const appSettings = useSelector(appSettingsSelector);

    const profile = await peak?.cycles.readHeatCycle(
      Constants.TEMP_HEAT_PROFILE_INDEX,
      {
        units: appSettings.tempPreference,
      },
    );

    if (!currentDevice || !profile) return;

    dispatch(
      updateDevice({
        id: currentDevice.id,
        tempHeatProfile: toHeatProfile(profile, state.profile.items),
      }),
    );
  },
);
